import { render, staticRenderFns } from "./ConsultarIcon.vue?vue&type=template&id=04456465&scoped=true"
var script = {}
import style0 from "./ConsultarIcon.vue?vue&type=style&index=0&id=04456465&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04456465",
  null
  
)

export default component.exports